<script setup>
import BubbleBlock from './BubbleBlock.vue';
import { onMounted, onUnmounted, ref } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { useReducedMotion } from '@/composables/useReducedMotion';

const bubbles = [
  {
    text: 'FOMO',
    class: 'top-5 -left-10 w-42 h-16 !text-lg origin-bottom-left',
    img: 1,
  },
  {
    text: 'Verðlaun / viðurkenning',
    class: 'top-15 -right-2 w-30 h-18 origin-bottom-left',
  },
  {
    text: 'Spilar með tilfinningar',
    class: 'top-30 -left-12 w-40 h-12 origin-bottom-left',
    img: 1,
    maxW: true,
  },
  {
    text: 'Auðvelt að halda áfram',
    class: 'top-35 -right-7 sm:-right-2 w-36 h-17 origin-bottom-left',
  },
  {
    text: 'Allt er áríðandi',
    class: 'top-70 -left-10 w-34 h-11 origin-bottom-left',
    img: 1,
    maxW: true,
  },
  {
    text: 'Árangur',
    class: 'top-88 -right-3 w-34 h-11 origin-bottom-left',
    img: 1,
    invertX: true,
    maxW: true,
  },
];
const { prefersReducedMotion } = useReducedMotion();

const wrapperRef = ref();
onMounted(() => {
  const bubbles = Array.from(
    wrapperRef.value.querySelectorAll('.bubble-block'),
  );

  gsap.set(bubbles, { opacity: 0 });

  let loopIdx = 0;
  const loop = () => {
    if (loopIdx === bubbles.length) {
      return; // exit from the loop
    }

    const el = bubbles[loopIdx];
    loopIdx++;
    gsap.fromTo(
      el,
      { opacity: 0, scale: 0, rotate: -10, y: -80 },
      {
        opacity: 1,
        rotate: 0,
        y: 0,
        scale: 1,
        ease: 'back.out(1.7)',
        duration: prefersReducedMotion.value ? 0 : 0.4,
        delay: prefersReducedMotion.value ? 0 : 0.3,
        repeat: false,
        onComplete: loop,
      },
    );
  };

  ScrollTrigger.create({
    trigger: wrapperRef.value,
    start: 'top-=300px center',
    once: true,
    onEnter: () => loop(),
  });
});

onUnmounted(() => {
  gsap.killTweensOf(bubbles);
});
</script>

<template>
  <div
    ref="wrapperRef"
    class="max-w-[260px] md:max-w-[300px] min-h-[480px] mb-4 flex items-center mr-4 shrink-0 pl-4"
    v-bounce-in
  >
    <div class="relative">
      <img
        src="/images/phone-bubbles/phone.webp"
        alt="einræðu konu"
        class="shrink-0 w-full h-full"
        loading="lazy"
        width="280"
        height="550"
      />
      <BubbleBlock
        v-for="bubble in bubbles"
        :key="bubble"
        :bubble="bubble"
        :class="[bubble.class, 'bubble-block']"
      />
    </div>
  </div>
</template>
